import React, { useEffect, useState, createContext } from 'react';
import PanoramaVFT from './PanoramaVFT';
import { FrameType } from '../models/FrameTypes';
import { Configuration } from '../models/Configuration';
import { PanoramaVFTConfig } from '../models/PanoramaVFTConfig';
import { isEmpty } from '../lib/Helper';
import SlideManagement from './SlideManagement';
import { AppSettings } from '../models/AppSetting';
import { ToastProvider } from '../components/ToastContext';
import { useParams } from 'react-router-dom';

type FrameConfiguration<T extends Configuration> = T;
const defaultSettings: AppSettings = {
    SERVER_ROOT_URL: "/",
    SAVE_URL: "/",
    IMAGE_URL: "/",
    HTML_URL: "/"
};

export const SettingsContext = createContext<AppSettings>(defaultSettings);

function Main() {
    const queryParams = new URLSearchParams(window.location.search);
    const inSlideManagement = isEmpty(queryParams.get('inSlideManagement')) ? false : queryParams.get('inSlideManagement') === "true";
    const inEditMode = isEmpty(queryParams.get('inEditMode')) ? false : queryParams.get('inEditMode') === "true";

    const [config, setConfig] = useState<FrameConfiguration<Configuration>>({
        title: "Empty config",
        type: FrameType.Empty
    });

    const [settings, setSettings] = useState<AppSettings>(defaultSettings);

    const { projID, moduleID, slideID } = useParams();

    useEffect(() => {
        let dataUrlPrefix = '.';
        let serverRoot = '';

        if (process.env!.NODE_ENV === "development") {
            serverRoot = 'https://localhost:44358';
        } else {
            serverRoot = "/Server";
        }

        let serverUrlPrefix = serverRoot;

        if (projID && moduleID && slideID) {
            dataUrlPrefix = "/slides/" + projID + "/" + moduleID + "/" + slideID;
            serverUrlPrefix += "/slide/" + projID + "/" + moduleID + "/" + slideID;
        }

        setSettings({
            SERVER_ROOT_URL: serverRoot,
            SAVE_URL: serverUrlPrefix + "/save",
            IMAGE_URL: serverUrlPrefix + "/images",
            HTML_URL: serverUrlPrefix + "/canvas"
        });

        (async function () {
            if (config.type === FrameType.Empty) {
                if (inSlideManagement) {
                    setConfig({
                        ...config,
                        title: "Slide Management",
                        type: FrameType.SlideList
                    });
                } else {
                    try {
                        let loadedConfig = await fetch(dataUrlPrefix + '/data/data.json', {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then((response) => {
                            return response.json();
                        });
                        setConfig(loadedConfig);
                    } catch { }
                }
            }
        })();
    }, [inSlideManagement, config, projID, moduleID, slideID]);

    return (
        <SettingsContext.Provider value={{
            SERVER_ROOT_URL: settings.SERVER_ROOT_URL,
            SAVE_URL: settings.SAVE_URL,
            IMAGE_URL: settings.IMAGE_URL,
            HTML_URL: settings.HTML_URL
        }} >
            <ToastProvider>
                {
                    config.type === FrameType.SlideList
                        ? (<SlideManagement />)
                        : (config.type === FrameType.PanoramaVFT)
                            ? (<PanoramaVFT globalConfig={(config as PanoramaVFTConfig)} inEditorMode={inEditMode} />)
                            : (config.type === FrameType.Empty)
                                ? (<div>No config detected</div>)
                                : (<div>b</div>)
                }
            </ToastProvider>
        </SettingsContext.Provider>
    );
}

export default Main;
